
{
  "familyId": "SWW-TT-UITGANG",
  "questions": [
    {
      "id": "SWW-TT-UITGANG-001",
      "familyId": "SWW-TT-UITGANG",
      "module": "SpellingWW",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_uitgang_keuze",
      "questionType": "verb_ending",
      "question": "Kies bij elk werkwoord de juiste uitgang.",
      "context": "Onthoud: ik = stam (geen uitgang). hij/zij/het = stam + t.",
      "data": {
        "verbEnding": {
          "variant": "tt-tstam",
          "items": [
            { "subject": "ik", "stem": "werk", "correct": "" },
            { "subject": "hij", "stem": "werk", "correct": "t" },
            { "subject": "zij", "stem": "fiets", "correct": "t" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam-regel tegenwoordige tijd",
            "content": "ik = alleen de stam (geen -t). jij/hij/zij/het = stam + t. Voorbeeld: ik werk, hij werkt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tt_ending_choice_ik_hij",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Bij 'ik' gebruik je alleen de stam: ik werk (geen -t). Bij 'hij' en 'zij' voeg je -t toe aan de stam: hij werkt, zij fietst.",
        "solutionSteps": [
          "ik werk → alleen de stam, geen uitgang",
          "hij werk + t → werkt",
          "zij fiets + t → fietst"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.ik-vorm-met-t", "label": "Bij ik-vorm onnodig -t gekozen" }
        ]
      }
    },
    {
      "id": "SWW-TT-UITGANG-002",
      "familyId": "SWW-TT-UITGANG",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_uitgang_keuze",
      "questionType": "verb_ending",
      "question": "Kies de juiste uitgang. Let op de -dt!",
      "context": "Stam eindigt al op een d? Bij hij/zij/het komt er nog een t bij: vind + t = vindt.",
      "data": {
        "verbEnding": {
          "variant": "tt-tstam",
          "items": [
            { "subject": "hij", "stem": "vind", "correct": "t" },
            { "subject": "ik", "stem": "vind", "correct": "" },
            { "subject": "zij", "stem": "rij", "correct": "dt" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De -dt-regel",
            "content": "Eindigt de stam op een d? Bij hij/zij/het voeg je tóch nog een -t toe: hij vindt. Bij 'ik' blijft het de kale stam: ik vind. Bij 'rijden' is de stam 'rij' → hij/zij rijdt (rij + dt).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tt_ending_choice_dt",
      "variantIndex": 2,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Vinden' heeft stam 'vind'. Bij 'hij' komt er een -t bij: vind + t = vindt. Bij 'ik' blijft het de stam: ik vind. 'Rijden' heeft stam 'rij' → zij rij + dt = rijdt.",
        "solutionSteps": [
          "hij vind + t → vindt (d-stam + t)",
          "ik vind → alleen de stam",
          "zij rij + dt → rijdt"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.dt-overgeneralize", "label": "-dt-regel onjuist toegepast" }
        ]
      }
    },
    {
      "id": "SWW-TT-UITGANG-003",
      "familyId": "SWW-TT-UITGANG",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_uitgang_keuze",
      "questionType": "verb_ending",
      "question": "Kies de juiste uitgang voor elk werkwoord.",
      "context": "Denk eerst: welk onderwerp hoort erbij? ik = stam, hij/zij = stam + t.",
      "data": {
        "verbEnding": {
          "variant": "tt-tstam",
          "items": [
            { "subject": "de kok", "stem": "proef", "correct": "t" },
            { "subject": "ik", "stem": "luister", "correct": "" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": {
            "verb": "proeven",
            "tense": "present",
            "persons": ["ik", "jij", "hij/zij"],
            "forms": ["proef", "proeft", "proeft"],
            "highlight": "hij/zij",
            "label": "Tegenwoordige Tijd"
          }
        }
      ],
      "conceptId": "tt_ending_choice_context",
      "variantIndex": 3,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'De kok' is hij/zij → stam + t: proef + t = proeft. 'Ik' krijgt geen uitgang: ik luister (alleen de stam).",
        "solutionSteps": [
          "de kok proef + t → proeft",
          "ik luister → alleen de stam"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.heel-ww-ipv-stam", "label": "Verkeerde uitgang bij hij/zij" }
        ]
      }
    }
  ]
}
